import Head from 'next/head'
import { Flex, Box } from '@chakra-ui/react'
import Sidebar, { SIDEBAR_WIDTH } from './Sidebar'

type Props = React.PropsWithChildren<{
  title: string
}>

const Component: React.FC<Props> = ({ title, children }) => (
  <>
    <Head>
      <title>{`${title} | Smaluna for Admin`}</title>
    </Head>
    <main>
      <Flex>
        <Sidebar />
        {/* スクロールバーの有無によってサイドバーの幅が変わらないように固定化したため、その幅を差し引いた幅をwidthに指定する */}
        <Box width={`calc(100% - ${SIDEBAR_WIDTH})`}>{children}</Box>
      </Flex>
    </main>
  </>
)

export default Component
